import { getDetailsTabRoutes, getDetailsTabRouteObjects, getSelectableResult } from "../../../utility/route";
import { childOfOrEqual } from "../../../router/functions";

export const contactListLDTRoutes = getDetailsTabRoutes('contact_list', 'contact_id');
export const contactGroupsListLDTRoutes = getDetailsTabRoutes('groups', 'group_id');
export const contactFilesListLDTRoutes = getDetailsTabRoutes('files', 'file_id');
export const contactImportExportRoute = "contact_import_export_route";

export const getContactDetailsSelectable = getSelectableResult(contactListLDTRoutes);
export const getContactGroupDetailsSelectable = getSelectableResult(contactGroupsListLDTRoutes);
export const getContactFileDetailsSelectable = getSelectableResult(contactFilesListLDTRoutes);

export const moduleRoutes = [
    contactListLDTRoutes,
    contactGroupsListLDTRoutes,
    contactFilesListLDTRoutes
];

const detailsRoutes = moduleRoutes.map(m => m.names.details);

export const childOfOrEqualDetails = route => {
    return detailsRoutes.map(r => childOfOrEqual(r)).some(f => f(route.name));
}